import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React, { FC } from 'react'
import { useSelector } from 'src/hooks'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'

type FeatureTextType = {
  text: string
  color?: string
  size?: string
  weight?: 'regular' | 'semiBold' | 'bold' | 'extraBold'
}

export type FeatureItemProps = {
  icon: IconType
  iconColor?: string
  iconSize?: number
  featureCopy: FeatureTextType[]
  density?: 'compact' | 'comfortable'
}

export const FeatureItem: FC<FeatureItemProps> = ({
  icon,
  iconColor = '#059669',
  iconSize = 18,
  featureCopy,
  density = 'comfortable',
}) => {
  const windowWidth = useSelector(state => state.window.width)
  const isMobile = windowWidth <= 520
  const isTablet = windowWidth < 950
  const defaultFontSize = isMobile ? '13px' : isTablet ? '14px' : '16px'

  return (
    <Flex
      justifyContent="start"
      alignItems="center"
      outset={density === 'compact' ? 'x0_5' : 'x_75'}
    >
      <Div position="relative" top="4px" outset={{ right: 'x1' }}>
        <Icon name={icon} color={iconColor} size={iconSize} />
      </Div>
      <Flex flexDirection="row" flexWrap="wrap">
        {featureCopy.map((text, index) => {
          return (
            <Text
              key={index}
              type="body"
              content={text.text}
              weight={text.weight ?? 'regular'}
              style={{
                color: text.color ?? '#404040',
                fontSize: text.size ?? defaultFontSize,
                whiteSpace: 'normal',
                lineHeight: 1.3,
              }}
            />
          )
        })}
      </Flex>
    </Flex>
  )
}
